import React, { useEffect, useState } from "react";
import { ModalHeader, ModalBody } from "reactstrap";
import AgentSelect from "./components/AgentSelect";
import { formTypes } from "./formTypes";
import AgentFound from "./components/AgentFound";
import EmailForm from "./components/EmailForm";
import WelcomeBackForm from "./components/WelcomeBackForm";
import AgentInfo from "./components/AgentInfo";
import MessageModal from "./components/MessageModal";
import { useDispatch, useSelector } from "react-redux";
import * as publicPortalActions from "../../../actions/publicportal";
import * as sessionActions from "../../../actions/session";
import Loading from "../../Loading";
import useAuth from "../../../hooks/useAuth";
import "./styles.scss";

const LoginForms = ({
  onClose,
  fromContact,
  history,
  listingAgent,
  listingID,
}) => {
  const [currentForm, setCurrentForm] = useState("EmailForm");
  const [typeMessage, setTypeMessage] = useState({});
  const [userName, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [showAlert, setShowAlert] = useState({ show: false, txt: "" });
  const { onSuccess, logout } = useAuth({ history, listingID });

  const forms = {
    EmailForm,
    WelcomeBackForm,
    AgentSelect,
    AgentInfo,
    AgentFound,
    MessageModal,
  };

  const dispatch = useDispatch();

  const {
    status,
    isFetching,
    agent,
    username,
    isDCLead,
    magicLinkSuccessMessage,
  } = useSelector((state) => state.publicportal);
  const isAuthenticating = useSelector(
    (state) => state.session.isAuthenticating
  );
  const isAuthenticated = useSelector((state) => state.session.isAuthenticated);

  useEffect(() => {
    if (isAuthenticated) {
      onSuccess();
    }
  }, [isAuthenticated, onSuccess]);

  const onLogin = ({ password }) => {
    // Clear any session/cookie/redux information as a precaution
    logout();
    // // Login using a fresh session
    dispatch(sessionActions.login({ username: userName, password }));
  };

  const onSubmit = (values, action) => {
    setShowAlert({ show: false, txt: "" });
    if (values.email) {
      setEmail(values.email);
    }

    dispatch(publicPortalActions[action](values));
  };

  const sendMagicLink = () => {
    dispatch(publicPortalActions.sendMagicEmail(email));
  };

  const backToFind = () => {
    dispatch({ type: "RESET_STATE" });
    setCurrentForm("AgentInfo");
  };

  useEffect(() => {
    switch (status) {
      case "FOUND_CHECKEMAIL":
        if (isDCLead) {
          setTypeMessage({ type: "AccountPending" });
          setCurrentForm("MessageModal");
        } else {
          setUserName(username);
          setCurrentForm("WelcomeBackForm");
        }
        break;

      case "NOT_FOUND_CHECKEMAIL":
        setShowAlert({
          show: true,
          txt: `No account found with ${email}, please use one of the options below`,
        });
        setCurrentForm("AgentInfo");
        dispatch({ type: "RESET_STATE" });
        break;

      case "NOT_FOUND_FINDAGENT":
        setShowAlert({
          show: true,
          txt: "No active or valid Agent found. Please try another option below",
        });
        dispatch({ type: "RESET_STATE" });
        break;

      case "FOUND_FINDAGENT":
        setCurrentForm("AgentFound");
        break;

      case "CREATELEAD_SUCCESS":
        setTypeMessage({ type: "SucessCreated" });
        setCurrentForm("MessageModal");
        break;

      case "SENDMAGICEMAIL_SUCCESS":
        setTypeMessage({
          type: "CheckInbox",
          msgEmail: magicLinkSuccessMessage,
        });
        setCurrentForm("MessageModal");
        break;

      default:
        break;
    }
  }, [status, username, isDCLead, email, magicLinkSuccessMessage, dispatch]);

  const handleOnClose = () => {
    onClose();
    dispatch({ type: "RESET_STATE" });
    setCurrentForm("EmailForm");
  };

  const Forms = () => {
    const Login = forms[currentForm];

    return (
      <Login
        onLogin={onLogin}
        typeMessage={typeMessage}
        agent={agent}
        showAlert={showAlert}
        handleForm={onSubmit}
        setCurrentForm={setCurrentForm}
        currentForm={currentForm}
        fromContact={fromContact}
        sendMagicLink={sendMagicLink}
        onClose={handleOnClose}
        backToFind={backToFind}
        listingAgent={listingAgent}
      />
    );
  };

  return (
    <>
      {isFetching || isAuthenticating ? (
        <Loading height="20vh" />
      ) : (
        <>
          <ModalHeader
            toggle={() => {
              handleOnClose();
            }}
          >
            {formTypes[typeMessage.type]?.icon && (
              <img
                src={formTypes[typeMessage.type]?.icon}
                alt="Form modal icon"
              ></img>
            )}
            <div>
              <h4>
                {
                  formTypes[
                    currentForm === "MessageModal"
                      ? typeMessage.type
                      : currentForm
                  ].headerTxt
                }
              </h4>
            </div>
          </ModalHeader>
          <ModalBody>
            <Forms />
          </ModalBody>
        </>
      )}
    </>
  );
};

export default LoginForms;
